<template>
  <div id="app">
    <drug-header class="myheader"></drug-header>
    <router-view />
  </div>
</template>

<script>
import DrugHeader from "./components/DrugHeader";
export default {
  name: 'App',
  components: {
    DrugHeader
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
  height: auto;
  min-height: 100vh;
  overflow: hidden;
  font-size: 14px;
  color: #333;
  position: relative;
  font-family: "PingFang SC-Regular", "PingFang SC";
  background-color: #f2f2f2;
  /* zoom: 0.8; */
}
.myheader {
  padding: 0;
  position: fixed;
  width: 100%;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue